export default "__VITE_ASSET__CbUuZ4Yb__"